import { TextButton } from '@creditornot/cb-button';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography, typographyCss } from 'common/typography';

import { VenueRowItem } from './VenueRowItem';
import { ReportVenueSelectItem } from './types';

const VISIBLE_VENUES_COUNT = 5;

const ContentRoot = styled.div`
  margin-block-start: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ViewAllButton = styled(TextButton)`
  ${typographyCss.Small};
  font-weight: 500;
`;

export const VenuesList = ({
  venueSelectItems,
  onViewAll,
}: {
  venueSelectItems: ReportVenueSelectItem[];
  onViewAll(): void;
}) => {
  const selectedVenueIds = venueSelectItems.map(venue => venue.id);
  const limitedVenueSelectItems = venueSelectItems.slice(0, VISIBLE_VENUES_COUNT);

  return (
    <ContentRoot>
      {limitedVenueSelectItems.length > 0 ? (
        limitedVenueSelectItems.map(venueSelectItem => {
          return <VenueRowItem venueSelectItem={venueSelectItem} key={venueSelectItem.id} isSelected />;
        })
      ) : (
        <Typography.Body3>
          <FormattedMessage id="insights.reports.venues.no-venues" />
        </Typography.Body3>
      )}
      {onViewAll && selectedVenueIds.length > VISIBLE_VENUES_COUNT && (
        <ViewAllButton size="small" onClick={onViewAll}>
          <FormattedMessage id="insights.reports.venues.view-all-count" values={{ count: selectedVenueIds.length }} />
        </ViewAllButton>
      )}
    </ContentRoot>
  );
};
